"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuthToken = void 0;
const node_fetch_1 = __importDefault(require("node-fetch"));
const url_1 = require("url");
async function getAuthToken(config, scope) {
    const params = new url_1.URLSearchParams();
    params.append("grant_type", "client_credentials");
    params.append("client_id", config.oktaAuthorizationClientId);
    params.append("client_secret", config.oktaAuthorizationClientSecret);
    if (scope) {
        params.append("scope", scope);
    }
    const response = await (0, node_fetch_1.default)(config.oktaAuthorizationTokenUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        body: params,
    });
    if (response.status !== 200) {
        throw new Error("Authorization token retrieval failure");
    }
    const jsonResponse = (await response.json());
    return jsonResponse.access_token;
}
exports.getAuthToken = getAuthToken;
